import { IKeyValue } from "motw_core/Entity/IKeyValue";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { UpdateKeyValueAsync } from "source/app/infrastructure/Data/KeyValues/UpdateKeyValue";
import { clearedDreamFilters } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Helpers/clearedDreamFilters";
import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";
import { Sounds } from "source/app/services/Sound/Sounds";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { ReadState } from "source/app/services/UI/State/ReadState";
import { State } from "source/app/services/UI/State/State";

export function ChangeEnergy(newValue: number, changeFilters: boolean = false) {
    const keyValue = ReadState<IKeyValue>(
        ESharedFunction.ShowCurrentEnergy_currentValue
    );

    if (!keyValue) {
        return;
    }

    PlaySound(keyValue, newValue, changeFilters);

    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);

    if (changeFilters) {
        const filters: Partial<IDreamsState> = {
            ...clearedDreamFilters,
            selectedDifficulty: newValue,
        };

        dreams.setState(filters as any);
    }

    UpdateKeyValueAsync(
        ESharedFunction.ShowCurrentEnergy_currentValue,
        newValue.toString()
    );
}

function PlaySound(
    keyValue: IKeyValue,
    newValue: number,
    changeFilters: boolean
) {
    if (changeFilters) {
        Sounds.kickdrum_heavy.Play();
    } else {
        const currentValue = Number.parseInt(keyValue.value);

        const soundToPlay =
            newValue > currentValue
                ? Sounds.electronic_tones_melodic_soft2
                : Sounds.electronic_tones_melodic_soft;

        soundToPlay.Play({ volume: 0.4 });
    }
}
